<template>
  <div class="transfer-account-create-update-margin">
    <b-row>
      <b-col sm="6">
        <i class="fas fa-money-bill-alt transfer-account-create-update-negative"></i>
        <Select title="Conta Origem" field="bankAccountFrom" :formName="formName" :required="true"
          v-model="transferAccount.bankAccountFrom" url="api/v1/finance/bank-account/select-all"
          :showNewRegister="false">
        </Select>

      </b-col>
      <b-col sm="6">
        <i class="fas fa-money-bill-alt transfer-account-create-update-positive"></i>
        <Select title="Conta Destino" field="bankAccountTo" :formName="formName" :required="true"
          v-model="transferAccount.bankAccountTo" url="api/v1/finance/bank-account/select-all" :showNewRegister="false">
        </Select>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="6">
        <InputText title="Descrição" field="description" :formName="formName" :required="true" :maxLength="100"
          v-model="transferAccount.description" />
      </b-col>
      <b-col sm="3">
        <DateTime title="Data" field="date" format="DD/MM/YYYY" type="date" placeholder :formName="formName"
          :required="true" v-model="transferAccount.date" />
      </b-col>
      <b-col sm="3">
        <InputDecimal title="Valor" field="unitValue" :formName="formName" :required="true" :markFormDirty="false"
          :maxLength="5" :precision="2" type="float" v-model="transferAccount.value" />
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12">
        <div class="text-center">
          <Button _key="btnSaveTransfer" type="primary" title="Salvar" :disabled="!isFormValid(formName)"
            classIcon="fa-regular fa-right-left" size="medium" :clicked="saveTransfer" />
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Select from "@/ui/forms/Select";
import InputText from "@/ui/forms/InputText";
import InputDecimal from "@/ui/forms/InputDecimal";
import DateTime from "@/ui/forms/DateTime";
import Button from "@/ui/forms/Button";

import TransferAccount from "../../models/TransferAccount";
import TransferAccountService from "../../services/transferAccount.service";

import { mapGetters, mapMutations } from "vuex";

export default {
  name: "TransferAccountCreateUpdate",
  components: {
    InputText,
    InputDecimal,
    Select,
    Button,
    DateTime,
  },
  data() {
    return {
      id: this.$route.params.id,
      formName: "transferAccountCreateUpdate",
      transferAccount: new TransferAccount(),
    };
  },
  computed: {
    ...mapGetters("validation", ["isFormValid"]),
    ...mapGetters("generic", ["event", "isLoading"]),
  },
  methods: {
    ...mapMutations("generic", ["hideModal", "removeLoading"]),
    ...mapMutations("validation", ["resetValidation", "removeFormDirty"]),
    async saveTransfer() {
      if (this.transferAccount.id) {
        const response = await TransferAccountService.update(this.transferAccount);
        if (response.success) this.hideModal();
        this.removeLoading(["btnSaveTransfer"]);
        return;
      }

      const response = await TransferAccountService.create(this.transferAccount);
      if (response.success) this.hideModal();
      this.removeLoading(["btnSaveTransfer"]);
    },
    update(data) {
      this.transferAccount = new TransferAccount();
      this.transferAccount.update(data);
    },
  },
  watch: {
    event: {
      handler(event) {
        if (event.name == "btnTransferCreate") {
          this.resetValidation(this.formName);
          this.transferAccount = new TransferAccount();
        }
        if (event.name == "transferUpdate") this.update(event.data);
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.transfer-account-create-update-margin {
  margin-right: 10px;
}

.transfer-account-create-update-positive {
  color: var(--color-brand);
}

.transfer-account-create-update-negative {
  color: var(--color-danger);
}
</style>
